import { Deferred } from '@inertiajs/react'
import { ConversationVolumeCard } from '@/components/analytics/ConversationVolumeCard'
import { ChannelMixCard } from '@/components/analytics/ChannelMixCard'
import { TopCountriesCard } from '@/components/analytics/TopCountriesCard'
import { WhenCustomersChatHeatmap } from '@/components/analytics/WhenCustomersChatHeatmap'
import { PanelSkeleton } from '@/components/analytics/PanelSkeleton'
import { usePanel } from '@/components/analytics/usePanel'
import type {
  ConversationVolumePanel,
  ChannelMixPanel,
  TopCountriesPanel,
  HeatmapPanel,
} from '@/types/analytics'

export function ConversationsSection() {
  return (
    <>
      <Deferred data="conversation_volume" fallback={<PanelSkeleton className="h-80" />}>
        <ConversationVolumeDeferred />
      </Deferred>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <Deferred data="heatmap" fallback={<PanelSkeleton className="h-72" />}>
          <HeatmapDeferred />
        </Deferred>
        <Deferred data="channel_mix" fallback={<PanelSkeleton className="h-72" />}>
          <ChannelMixDeferred />
        </Deferred>
      </div>

      <Deferred data="top_countries" fallback={<PanelSkeleton className="h-56" />}>
        <TopCountriesDeferred />
      </Deferred>
    </>
  )
}

function ConversationVolumeDeferred() {
  const data = usePanel<ConversationVolumePanel>('conversation_volume')
  return data ? <ConversationVolumeCard data={data} /> : null
}

function HeatmapDeferred() {
  const data = usePanel<HeatmapPanel>('heatmap')
  return data ? <WhenCustomersChatHeatmap data={data} /> : null
}

function ChannelMixDeferred() {
  const data = usePanel<ChannelMixPanel>('channel_mix')
  return data ? <ChannelMixCard data={data} /> : null
}

function TopCountriesDeferred() {
  const data = usePanel<TopCountriesPanel>('top_countries')
  return data ? <TopCountriesCard data={data} /> : null
}
